(() => {
  const subscriberKey = 'gtn_ebook_subscribed_v1';
  const read = k => { try { return localStorage.getItem(k); } catch { return null; } };
  const write = (k, v) => { try { localStorage.setItem(k, v); } catch {} };
  if (document.querySelector('[data-gtn-guide-success]')) write(subscriberKey, 'true');
  const popup = document.querySelector('[data-gtn-guide-popup]');
  if (!popup || typeof popup.showModal !== 'function' || popup.dataset.gtnReady) return;
  popup.dataset.gtnReady = 'true';
  const teaser = document.querySelector('[data-gtn-guide-open]');
  const key = 'gtn_ebook_popup_v1';
  const repeatDays = Number(popup.dataset.repeatDays || 7);
  let timer;
  let previousFocus;
  let prompted = false;
  const alreadySubscribed = () => popup.dataset.knownSubscriber === 'true' || read(subscriberKey) === 'true';
  const recentlyClosed = () => {
    const value = Number(read(key));
    return value > 0 && Date.now() - value < repeatDays * 86400000;
  };
  const toolsVisible = () => {
    const tools = document.getElementById('poker-tools');
    if (!tools) return false;
    const rect = tools.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  };
  const anotherDialogVisible = () => Array.from(document.querySelectorAll('dialog[open],[aria-modal="true"]')).some(el => el !== popup && el.getBoundingClientRect().height > 0);
  const safeToPrompt = () => !document.hidden && !toolsVisible() && !anotherDialogVisible() && !document.activeElement?.matches('input,textarea,select,[contenteditable="true"]');
  const open = manual => {
    if (popup.open || alreadySubscribed()) return;
    if (!manual && (!safeToPrompt() || recentlyClosed())) return;
    previousFocus = document.activeElement;
    popup.showModal();
    popup.querySelector('[data-gtn-guide-close]')?.focus();
    prompted = true;
    clearTimeout(timer);
    if (teaser) teaser.hidden = true;
  };
  const close = () => {
    if (!popup.open) return;
    write(key, String(Date.now()));
    popup.close();
    if (teaser && !alreadySubscribed()) teaser.hidden = false;
    previousFocus?.focus();
  };
  popup.querySelectorAll('[data-gtn-guide-close]').forEach(button => button.addEventListener('click', close));
  popup.addEventListener('cancel', event => { event.preventDefault(); close(); });
  popup.addEventListener('click', event => {
    if (event.target !== popup) return;
    const rect = popup.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  teaser?.addEventListener('click', () => open(true));
  if (popup.querySelector('[data-gtn-guide-success],[data-gtn-guide-error]') && window.location.hash === '#GtnGuidePopupForm') {
    previousFocus = document.activeElement;
    popup.showModal();
    popup.querySelector('[data-gtn-guide-close]')?.focus();
    prompted = true;
  }
  const prompt = () => {
    if (prompted || alreadySubscribed() || recentlyClosed()) return;
    if (safeToPrompt()) open(false);
    else timer = setTimeout(prompt, 5000);
  };
  if (window.Shopify?.designMode && teaser && !alreadySubscribed() && !popup.open) teaser.hidden = false;
  else if (!alreadySubscribed() && !recentlyClosed()) timer = setTimeout(prompt, Number(popup.dataset.delay || 25) * 1000);
  else if (teaser && !alreadySubscribed()) teaser.hidden = false;
  window.addEventListener('pagehide', () => clearTimeout(timer), { once: true });
})();
